import { Outlet, useNavigate } from "react-router-dom";
import React, { PropsWithChildren, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/store/store";
import { auth } from "@/services/firebase";
import { logout } from "@/services/logout";
import { setCurrentUser } from "@/store/reducers/admin.slice";

const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const user = useSelector((state: RootState) => state.user.user);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      try {
        if (user) {
          dispatch(setCurrentUser(user));
          const token = await user.getIdToken();
          localStorage.setItem("token", token);

          // Get ID token result to calculate expiration time
          const idTokenResult = await user.getIdTokenResult();
          const expirationTime = new Date(
            idTokenResult.expirationTime
          ).getTime();
          const currentTime = new Date().getTime();
          const timeToExpire = expirationTime - currentTime;

          // Set a timeout to log out the user when the token expires
          setTimeout(() => {
            dispatch(logout());
            navigate("/login");
          }, timeToExpire);
        } else {
          throw new Error("User is not authenticated");
        }
      } catch (err) {
        dispatch(logout());
        navigate("/login");
      }
    });

    return () => unsubscribe();
  }, [dispatch, navigate]);

  return user ? <Outlet /> : null;
};

export default ProtectedRoute;
